// extracted by mini-css-extract-plugin
export default {"blob":"blob--P1ha6","cyan":"cyan--CEvBZ","pink":"pink--tLbcD"};